document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.classList.toggle('is-open', !expanded);
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const productData = form.querySelector('[data-product-json]');
    const idInput = form.querySelector('input[name="id"]');
    const submit = form.querySelector('button[type="submit"]');

    if (!productData || !idInput) return;

    let product;
    try {
      product = JSON.parse(productData.textContent);
    } catch (error) {
      return;
    }

    form.addEventListener('change', () => {
      const selectedOptions = Array.from(form.querySelectorAll('.variant-field')).map((field) => {
        const checked = field.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      const variant = product.variants.find((item) => {
        return item.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!variant) {
        if (submit) submit.disabled = true;
        return;
      }

      idInput.value = variant.id;
      if (submit) submit.disabled = !variant.available;
    });
  });
});
